module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-14.d04d2458.png";